import React, { Component } from 'react';

/*Material ui template */
import TextField from '@material-ui/core/TextField';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

export default class ComponentInfo extends Component {
  render() {
    return (
      <React.Fragment>

        <DialogTitle id="form-dialog-title">Work Component Information</DialogTitle>
         <DialogContent>
            <TextField
              required
              id="name"
              name="name"
              label="Work Component Name"
              fullWidth
              autoComplete="Name"
              value={this.props.component.name || ''}
              onChange={this.props.handleChange}
              disabled={this.props.reviewActive}
              error={this.props.errores.component.name}
              helperText={this.props.errores.component.name}
            />
          </DialogContent>
  </React.Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/wbs/ComponentInfo.js